import dayjs from 'dayjs';

import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';

import Icon from 'components/global/Icon';
import Image from 'components/global/Image';
import Tooltip from 'components/global/Tooltip';
import Typography from 'components/global/Typography';

import { faCircleInfo } from '@fortawesome/pro-regular-svg-icons';

import { SectionWrapper } from '../OnboardingV2/Onboarding.styled';
import * as S from './QuickTips.styled';

const QuickTips = () => {
	const { t } = useTranslation();

	const translationExists = (key) => {
		return t(key) !== key;
	};

	useEffect(() => {
		const currentDay = dayjs().date();
		const storedTip = JSON.parse(localStorage.getItem('dailyTip')) || {};
		const lastShownDay = storedTip.day || 0;

		if (currentDay !== lastShownDay) {
			const nextTipIndex = (storedTip.index || 0) + 1;
			const newTipIndex = translationExists(`dailyTip${nextTipIndex}Title`)
				? nextTipIndex
				: // eslint-disable-next-line sonarjs/pseudo-random
					Math.floor(Math.random() * storedTip.index);

			localStorage.setItem('dailyTip', JSON.stringify({ index: newTipIndex, day: currentDay }));
		}
	}, []);

	const storedTip = JSON.parse(localStorage.getItem('dailyTip')) || {};
	const tipIndex = storedTip.index || 1;

	return (
		<SectionWrapper>
			<S.Header>
				<Typography variant="p2" fontWeight="700">
					quickTips
				</Typography>
				<Tooltip placement="right" title={'quickTipsTooltip'}>
					<Icon icon={faCircleInfo} />
				</Tooltip>
			</S.Header>

			<S.ContentContainer>
				<Image
					url="https://storage.googleapis.com/tryoto-public/public/assets/images/homepage/quickTips.svg"
					width="6rem"
					height="6rem"
				/>
				<div>
					<Typography noWrap gutterBottom variant="caption" color="var(--content-3)" fontWeight="700">
						{t(`dailyTip${tipIndex}Title`).toUpperCase()}
					</Typography>
					<Typography variant="p3" noWrap fontWeight="500">
						{t(`dailyTip${tipIndex}Description`)}
					</Typography>
				</div>
			</S.ContentContainer>
		</SectionWrapper>
	);
};

export default QuickTips;
